export type FixedPreferenceValues = {
  crownMaterial: string | null;
  inlayOnlayMaterial: string | null;
  veneerMaterial: string | null;
  temporaryMaterial: string | null;
  supplement: string;
  bridgeMaterial: string | null;
  bridgeType: string | null;
  ponticShape: string;
  ceramicGingiva: string;
  inlayCoreMaterial: string | null;
  scanPostType: string | null;
  keyedInlayCore: string;
  crownWithInlayCore: string;
  step: string;
};

export const getFixedPreferenceDefaults = (): FixedPreferenceValues => ({
  crownMaterial: null,
  inlayOnlayMaterial: null,
  veneerMaterial: null,
  temporaryMaterial: null,
  supplement: "",
  bridgeMaterial: null,
  bridgeType: null,
  ponticShape: "",
  ceramicGingiva: "",
  inlayCoreMaterial: null,
  scanPostType: null,
  keyedInlayCore: "",
  crownWithInlayCore: "",
  step: "",
});
